var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 8.467 8.467",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.53 1.588v5.291h.528v-.794h6.35v.794h.53V4.498h-6.88v-2.91zm1.851.793a.798.798 0 0 0-.794.794c0 .435.359.794.794.794s.794-.359.794-.794a.798.798 0 0 0-.794-.794zm1.059 0V3.97h4.497v-.53c0-.581-.476-1.058-1.058-1.058z"
  })));
};
export default SvgBed;